import { render, staticRenderFns } from "./stocksTable.vue?vue&type=template&id=52a2d989&"
import script from "./stocksTable.vue?vue&type=script&lang=ts&"
export * from "./stocksTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports